var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 75 150"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "arrow_svg__a",
  d: "m-112.25 34.8-3 2.07-3-2.07a.33.33 0 0 0-.44.08.31.31 0 0 0 .08.43l3.19 2.18h.33l3.19-2.18a.31.31 0 0 0 .08-.43.32.32 0 0 0-.43-.08Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "arrow_svg__a",
  d: "m-115.26 31.92 2.64 1.78-2.64 1.78-2.64-1.78Zm-3.48 1.67v.19l3.19 2.15h.33l3.32-1.93v-.08l-3.19-2.15h-.28l-3.19 2.15Z"
})), /*#__PURE__*/React.createElement("style", null, ".arrow_svg__a{fill:none}"))), /*#__PURE__*/React.createElement("path", {
  d: "M35.22 5.22a99.22 99.22 0 0 0 0 140.16l33-33a52.52 52.52 0 0 1 0-74.11Z",
  style: {
    fill: "#fff"
  }
}));
export { SvgArrow as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow.84594285.svg";